import { render, staticRenderFns } from "./PagoSinpe.vue?vue&type=template&id=1eeceb8e"
import script from "./PagoSinpe.vue?vue&type=script&lang=js"
export * from "./PagoSinpe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports